import { Reveal } from "./Reveal";
import { IMAGES } from "./data";

const spans = [
  "md:col-span-7 h-[380px]",
  "md:col-span-5 h-[380px]",
  "md:col-span-4 h-[340px]",
  "md:col-span-4 h-[340px]",
  "md:col-span-4 h-[340px]",
  "md:col-span-12 h-[420px]",
];

export default function Portfolio() {
  return (
    <section id="portfolio" data-testid="portfolio-section" className="relative py-28 lg:py-40 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <Reveal>
              <p className="overline mb-6">Selected Work</p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-heading font-light text-4xl sm:text-5xl lg:text-6xl leading-tight tracking-tight">
                A portfolio of the extraordinary.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm font-light text-foreground/60">
              A glimpse into the homes, cities and journeys we've helped clients call their own — across borders and around the world.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
          {IMAGES.gallery.map((src, i) => (
            <Reveal key={i} delay={(i % 3) * 0.1} className={spans[i]}>
              <div data-testid={`portfolio-item-${i}`} className="group relative h-full w-full overflow-hidden border border-white/10">
                <img
                  src={src}
                  alt={`Portfolio ${i + 1}`}
                  className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-background/0 group-hover:bg-background/20 transition-colors duration-500" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
